import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import AssetsForm from 'components/assets/form_sections';
import AssetsFormHandlers from 'containers/assets/AssetsFormHandlers';

import { addAssetNote, removeAssetNote, modifyAssetNote } from 'containers/assets/actions';
import { updateAsset, requestUpdateAsset } from 'containers/assets/actions';
import { addGrowlMessage as addMsg } from 'messages/actions';

import { getUser } from 'auth/selectors';
import { Form } from 'common/components';
import { createRoute } from 'lib/util';

class AssetsEditNotesView extends Component {
  static propTypes = {
    addAssetNote: PropTypes.func.isRequired,
    asset: PropTypes.object.isRequired,
    modifyAssetNote: PropTypes.func.isRequired,
    removeAssetNote: PropTypes.func.isRequired,
    addMsg: PropTypes.func.isRequired,
    updateAsset: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleSubmit = (e) => {
    e && e.preventDefault();
    let { addMsg, asset, company, history, subcompany, updateAsset, requestUpdateAsset } =
      this.props;

    const aId = asset.id;
    const cId = company.id;
    const sId = subcompany.id;

    asset = omit(asset, [
      '_fiscalDepreciationResult',
      '_financialDepreciationResult',
      '_extraDepreciationsResult',
    ]);

    asset._notes = asset._notes
      .filter((note) => note.text)
      .map((note) => {
        if (!note.createdAt) delete note.id;
        return note;
      });

    const isRequest = !!this.props.match.params.isRequest;
    const method = isRequest ? requestUpdateAsset : updateAsset;

    method(aId, cId, sId, asset).then(({ value }) => {
      addMsg(value.message, 'success', 'common.success');
      history.push(`/companies/${cId}/subcompanies/${sId}/assets`);
    });
  };

  render = () => {
    return (
      <AssetsFormHandlers
        render={({ isSubmitted, isSaving }) => (
          <form onSubmit={this.handleSubmit} noValidate autoComplete="false">
            <AssetsForm.Notes
              asset={this.props.asset}
              user={this.props.user}
              handleAddNote={this.props.addAssetNote}
              handleRemoveNote={this.props.removeAssetNote}
              handleModifyNote={this.props.modifyAssetNote}
            />
            <div className="col-md-12 mt-3">
              <Form.Button
                type={'submit'}
                text={this.props.t('actions.save')}
                isLoading={isSaving}
                disabled={isSaving}
                extraClassName={'pull-right btn-xs-block'}
              />

              <Form.Link
                to={createRoute(this.props.company.id, this.props.subcompany.id, 'assets')}
                className={classnames('btn btn-secondary pull-right mr-3', {
                  disabled: isSaving,
                })}
              >
                {this.props.t('actions.cancel')}
              </Form.Link>
              <div className="clearfix" />
            </div>
          </form>
        )}
      />
    );
  };
}

const mapStateToProps = (state) => ({ user: getUser(state) });
const mapDispatchToProps = {
  addAssetNote,
  removeAssetNote,
  modifyAssetNote,
  updateAsset,
  requestUpdateAsset,
  addMsg,
};

export default withRouter(
  translate()(connect(mapStateToProps, mapDispatchToProps)(AssetsEditNotesView))
);



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetsEditNotesSection.js